import camelcaseKeys from 'camelcase-keys'

export class MetricData {
  id: number
  value: number
  effectiveAt: string

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}

export class BodyMeasurements {
  bodyWeightNotes: string = ''
  bodyCircumferenceNotes: string = ''
  bloodPressureNotes: string = ''

  metrics: any = {}
  goals: any = {}

  constructor (attributes) {
    this.bodyWeightNotes = attributes.bodyWeightNotes
    this.bodyCircumferenceNotes = attributes.bodyCircumferenceNotes
    this.bloodPressureNotes = attributes.bloodPressureNotes

    if (attributes.metrics) {
      attributes.metrics.forEach(metric => {
        this.metrics[metric.name] = metric.data.map(data => new MetricData(camelcaseKeys(data, { deep: true })))
      })
    }

    if (attributes.goals) {
      attributes.goals.forEach(metric => {
        this.goals[metric.name] = metric.data.map(data => new MetricData(camelcaseKeys(data, { deep: true })))
      })
    }
  }
}
